import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { encodeQuery } from '../../services/search-page-url';
import { push } from '../../services/router-utils';
import SearchInput from '../../components/search-input';
import { isAppBundle } from '../../services/section-route-utils';
import { navigateToBlog } from '../../services/navigate-to-section';

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      onClick: query => dispatch => {
        const to = `/search/${encodeQuery(query)}`;

        if (isAppBundle()) {
          dispatch(push(to));
        } else {
          navigateToBlog(to);
        }
      },
    },
    dispatch,
  );

export default connect(
  undefined,
  mapDispatchToProps,
)(SearchInput);
